<template>
    <v-dialog
        v-model="dialogModel"
        max-width="650"
        @click:outside.prevent="closeDialog"
    >
        <v-card class="pa-5">
            <v-btn icon color="black" absolute top right @click="closeDialog">
                <v-icon>$close</v-icon>
            </v-btn>
            <h3 class="text-center mb-10">Resources</h3>
            <div class="mb-5">
                <v-card
                    v-for="(resource, i) in webResources"
                    :key="i"
                    class="pa-0 d-flex align-center elevation-0 gap-4"
                    style="gap: 16px;"
                >
                    <v-col cols="5" class="pa-0">
                        <v-text-field
                            :value="resource.name"
                            @input="updateResource(i, 'name', $event)"
                            single-line
                            solo
                        />
                    </v-col>
                    <v-col cols="5" class="pa-0">
                        <v-text-field
                            :value="resource.url"
                            @input="updateResource(i, 'url', $event)"
                            single-line
                            solo
                        />
                    </v-col>
                    <v-col>
                        <v-btn fab small primary="transparent" class="elevation-0"  @click="deleteHandler(i)">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-col>
                </v-card>
            </div>
            <v-form ref="resourcesForm" lazy-validation>
                <v-flex xs12 class="d-flex align-center" style="gap: 16px;">
                    <v-col cols="5" class="pa-0">
                        <v-text-field
                            v-model="newName"
                            placeholder="Resource name"
                            :rules="newNameRules"
                            value="true"
                            required="false"
                            autocomplete="off"
                        />
                    </v-col>
                    <v-col cols="5" class="pa-0">
                        <v-text-field
                            v-model="newUrl"
                            placeholder="Resource url"
                            :rules="newUrlRules"
                            value="true"
                            required="false"
                            autocomplete="off"
                        />
                    </v-col>
                    <v-btn color="primary" @click="addHandler" class="ml-2">Add</v-btn>
                </v-flex>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
    import { mapGetters } from 'vuex'
    import validationRules from '@/common/validationRules'

    export default {
        name: 'ResourcesDialog',
        props: ['isOpen'],
        data: () => ({
            newName: '',
            newUrl: '',
            newNameRules: [validationRules.required],
            newUrlRules: validationRules.url
        }),
        computed: {
            ...mapGetters(['getWebResources']),
            webResources () {
                return this.getWebResources
            },
            dialogModel: {
                get () {
                    return this.isOpen
                },
                set (value) {
                    this.$emit('update:isOpen', value)
                }
            }
        },
        methods: {
            closeDialog () {
                this.$emit('update:isOpen', false)
            },
            addHandler () {
                if (this.$refs.resourcesForm && !this.$refs.resourcesForm.validate()) return

                const name = (this.newName || '').trim()
                const url = (this.newUrl || '').trim()

                this.$store.commit('SETTINGS_ADD_WEB_RESOURCE', { name, url })
                this.newName = ''
                this.newUrl = ''
                const form = this.$refs.resourcesForm
                if (form && form.resetValidation) form.resetValidation()
            },
            deleteHandler (index) {
                this.$store.commit('SETTINGS_DELETE_WEB_RESOURCE', index)
            },
            updateResource (index, field, value) {
                this.$store.commit('SETTINGS_UPDATE_WEB_RESOURCE', {
                    index,
                    patch: { [field]: value }
                })
            }
        }
    }
</script>
